import { Alert, Snackbar } from '@mui/material';
import { FC } from 'react';

interface MessagePopupProps {
  alert: {
    open: boolean;
    message: string;
    severity: 'error' | 'success';
  };
  setAlert: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      message: string;
      severity: 'error' | 'success';
    }>
  >;
}

const MessagePopup: FC<MessagePopupProps> = ({ alert, setAlert }) => {
  return (
    <Snackbar
      open={alert.open}
      autoHideDuration={2000}
      onClose={() => setAlert(prev => ({ ...prev, open: false }))}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity={alert.severity}
        variant="filled"
        sx={{ width: '100%' }}
        onClose={() => setAlert(prev => ({ ...prev, open: false }))}
      >
        {alert.message}
      </Alert>
    </Snackbar>
  );
};

export default MessagePopup;
